// extracted by mini-css-extract-plugin
module.exports = {"header":"_20uk8","logo":"_1Ml6S","tooltip":"_8COr5","right":"sGqxO","left":"uiMag","bottom":"jSOZ1","top":"_4cRUX"};